//亚冬会 full
import PlatfromCSMeetAsianWinterGamesFull from '@containers/platfrom_compreSportsMeet/asianWinterGamesFull_AWG.vue'

export default {
  PlatfromCSMeetAsianWinterGamesFull,
}
